import React, {useState} from 'react'
import PropTypes from 'prop-types'
import PhoneInput from 'react-phone-number-input/input'
import { isPossiblePhoneNumber } from 'react-phone-number-input'
import USD from '../usd'
import ReactModal from "react-modal"

const ReceiptModal = props => {
  const [phone, setPhone] = useState('')
  const [active, setActive] = useState(false)

  const currentTransaction = props.transactions[props.currentTransactionId]
  if (!currentTransaction) return null

  const handleSend = e => {
    e.preventDefault()
    props.onSend({phone: phone, id: currentTransaction.receipt.id})
    setActive(true)
  }

  const handleDone = () => {
    setPhone('')
    setActive(false)
    props.hideReceipt()
  }

  return (
    <ReactModal className='receipt__body' overlayClassName='receipt' isOpen={props.isOpen}  closeTimeoutMS={500}>
    <div className='receipt__wrap'>
      <div className='receipt__money'>
        <USD val={Number(currentTransaction.totalAmountWithoutTip)}/>
      </div>
      <form>
        <div className='receipt__inp-wrap'>
          <img className='receipt__chat' src='/images/text-receipt/receipt.png'/>
          <PhoneInput
            className='receipt__inp'
            placeholder='Text Receipt'
            autoFocus={true}
            maxLength='16'
            country="US"
            value={phone}
            onChange={e => setPhone(e || '')}
          />
          <button
            disabled={!isPossiblePhoneNumber(phone)}
            onClick={e => handleSend(e)}
            className={active ? 'receipt__btn-sm-active-done':
            isPossiblePhoneNumber(phone) ? 'receipt__btn-sm-active':'receipt__btn-sm'}
          >
            Send
          </button>
          <img className={active ? 'receipt__sent':'receipt__unsent'} src='/images/text-receipt/sent.png'/>
        </div>
      </form>
      <div>
        <button onClick={e => handleDone()} className='receipt__btn'>Done</button>
      </div>
    </div>
    </ReactModal>
  )
}

ReceiptModal.propTypes = {
  hideReceipt: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  transactions: PropTypes.object.isRequired,
  currentTransactionId: PropTypes.number,
}

export default ReceiptModal;
